import { useState } from 'react';
import { useClerk } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@/hooks/components/common/toast/useToast';
import { axiosInstance } from '@/lib/api/axiosConfig';

export const useLogout = () => {
    const [isLoading, setIsLoading] = useState(false);
    const { signOut } = useClerk();
    const navigate = useNavigate();
    const showToast = useToast();

    const logout = async (): Promise<void> => {
        setIsLoading(true);
        try {
            // call the backend to clear the session and cookies.
            await axiosInstance.post('/auth/signout/');

            await signOut();
            showToast({
                type: 'success',
                title: 'Logged out successfully',
                message: 'You have been signed out of your account'
            });
            navigate('/');
        } catch (err: unknown) {
            const error = err instanceof Error ? err.message : 'Logout failed';
            showToast({
                type: 'error',
                title: 'Logout failed',
                message: error
            });
        } finally {
            setIsLoading(false);
        }
    };

    return {
        isLoading,
        logout
    };
};